export const INVITE_ID_STORAGE_KEY = "inviteId";
export const TP_VIDEO_TOKEN_STORAGE_KEY = "tpVideoToken";
export const TP_VIDEO_INTERNAL_NAME_STORAGE_KEY = "tpVideoInternalName";
